import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import Modal from '../../../../common/Modal'
import SubmitButton from '../../../../common/buttons/SubmitButton'
import CancelButton from '../../../../common/buttons/CancelButton'

import classes from './RegistrationAuthModal.module.scss'

const RegistrationAuthModal = ({ isOpen, onClose, onCreateAccount, onLogin }) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classes.modal}>
      <div className='d-flex flex-column align-items-center text-center'>
        <h2 className={classNames(classes.title, 'mb-3')}>{t('programs.landing.registrationAuthModal.title')}</h2>
        <p className={classNames(classes.message, 'mb-5')}>
          {t('programs.landing.registrationAuthModal.message')}
        </p>

        <div className='row w-100'>
          <div className='col-6'>
            <SubmitButton
              type='button'
              buttonMessage={t('programs.landing.registrationAuthModal.createAccount')}
              onClick={onCreateAccount}
              noTopMargin
            />
          </div>

          <div className='col-6'>
            <CancelButton onClick={onLogin} buttonMessage={t('programs.landing.registrationAuthModal.login')} />
          </div>
        </div>
      </div>
    </Modal>
  )
}

RegistrationAuthModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateAccount: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
}

export default RegistrationAuthModal
